<template>
  <v-container fluid calss="pa-0 ma-8">
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      class="elevation-1"
      hide-default-footer
    ></v-data-table>
  </v-container>
</template>

<script>
export default {
  props: ["items", "headers"],
  components: {},
  data: () => ({}),
};
</script>

<style></style>
